import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
const urlContrato = '/service/materiais/eventoLicitacao/'

class EventosLicitacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            numeroTotal: filtro.numeroTotal,
        }

        return this.conex.post(urlContrato + 'eventosLicitacao/', JSON.stringify(data))
    }
}

export default EventosLicitacaoService
